// extracted by mini-css-extract-plugin
export default {"faq1":"about_faq1__YWd7N","about":"about_about__4X24V","main":"about_main__o+4S2"};